import React, { useContext } from "react";
import { Wrapper, Headers, Container } from "./style";
import { ThemeContext } from "../../ThemedContext/Provider";
import TopSongs from "../../components/TopSongs";

const AllSongs = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper themes={theme}>
      <Headers></Headers>
      <Container>
        <TopSongs subTitle='All Songs' />
      </Container>
    </Wrapper>
  );
};

export default AllSongs;
